import useRequest from '@/websdk/utils/request';

export default (function () {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: `/api/sealing/inspection/main`,
    name: 'SEALING_INSPECTION_GET',
    method: 'GET',
  });
  return [isRequestSuccessed, data || [], exec];
  // }
});
